import { createPortal } from 'react-dom'

// EVA-266 (Tier 1 unification): the realtime connection badge portalled into a
// grid's card-header. This markup (span.connection-status-inline + status dot +
// the three status labels, styled by _handsontable_shared.scss) was duplicated
// verbatim across six grid components; only the label text varied, so it is
// passed in via `labels`. Each grid keeps its own (differing) card-header mount
// effect and passes the resulting element as `mountEl`.
export default function ConnectionStatus({ status, mountEl, labels = {} }) {
  if (!mountEl) return null

  return createPortal(
    <span className={`connection-status-inline connection-${status}`}>
      <span className="status-dot"></span>
      {status === 'connected' && labels.connected}
      {status === 'disconnected' && labels.disconnected}
      {status === 'connecting' && labels.connecting}
    </span>,
    mountEl,
  )
}
